// Détecteur de double appui : deux appuis rapprochés (DOUBLE_TAP_MS) déclenchent `onDouble`. Le même détecteur
// sert au toucher et à la souris, sur l'événement pointerup (et non dblclick : pas de zoom au double-tap mobile,
// même comportement partout). Un triple appui ne redéclenche pas : le compteur repart de zéro après un double.
// Pur : l'horloge est injectable pour les tests.
import { DOUBLE_TAP_MS } from '../config/constants.js';

/**
 * @param {(event?: Event) => void} onDouble
 * @param {{ maxMs?: number, now?: () => number }} [options]
 */
export function createDoubleTap(onDouble, { maxMs = DOUBLE_TAP_MS, now = () => performance.now() } = {}) {
  let last = null;
  return {
    /** À appeler à chaque pointerup. */
    tap(event) {
      const t = now();
      if (last !== null && t - last <= maxMs) {
        last = null;
        onDouble(event);
      } else {
        last = t;
      }
    },
    reset() {
      last = null;
    },
  };
}
